import React, { Component } from 'react'
import { COLORS } from '../pages/theme';
import { PlaylistAddCheckOutlined, MoreHorizOutlined } from '@material-ui/icons';
import { ScoredTag, TransparentButton } from './basic_items';
import { formatMoney } from '../lib/util';
import { CustomStatsSmall } from './custom_stat';
import { Tag, Divider, Collapse, Descriptions, Tooltip, Row, Col, Table, Button, Popconfirm } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import ErrorWrapper from '../lib/error_wrapper';


const peers_cols = ({ onViewDetailClicked, onRemoveClicked }) => [
    {
        title: "Type",
        dataIndex: "type",
        width: 53,
        key: 'type',
        render: (value, row, index) => {
            return <div title={value == 'C' ? "Credit" : (value == 'D' ? "Debit" : "N/A")} className={value === 'D' ? 'debit-circle' : value == 'C' ? 'credit-circle' : 'na-circle'}>
                {value||"-"}
            </div>
        }
    },
    {
        title: "Txn Date",
        dataIndex: "txn_date",
        width: 100,
        key: 'txn_date'
    }, 
    // {
    //     title: "Tran ID",
    //     dataIndex: "transaction_id",
    //     width: 100,
    //     key: 'transaction_id'
    // }, 
    {
        title: "Particular",
        dataIndex: "description",
        key: 'description'
    }, {
        title: "Amount",
        dataIndex: "amount",
        width: 100,
        key: 'amount',
        render: (amount = 0) => formatMoney(amount, 2, '.', ',')
    },
    {
        title: "ACTION",
        dataIndex: "id",
        width: 100,
        key: 'action',
        render: (id) => <div style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
        }}>

            <MoreHorizOutlined
            titleAccess='View Detail'
            className='basic-icon hand-cursor' onClick={()=>{
                console.log("detail clicked")
                typeof onViewDetailClicked==='function'&&onViewDetailClicked(id)
            }} />
            <Divider type='vertical' />
            <Popconfirm title="Do you want to remove this peer?" onConfirm={() => {
                typeof onRemoveClicked === 'function' && onRemoveClicked(id)

            }}><Button style={{
                color: 'red',
                padding:0
            }} type='link' >Remove</Button></Popconfirm>
        </div>
    }
]

class TransactionBatchAggregatedItem extends Component {
    render() {
        let data = this.props.data || {};
        let selectedID = this.props.selectedID;
        let itemID = this.props.itemID;
        let isSelectable = this.props.isSelectable;
        let batch_mode = this.props.batch_mode || 'Manual';
        let selected_left = this.props.selected_left;
        let selected = (itemID && selectedID && (itemID === selectedID));

        let side = this.props.side;


        let remove_peers_resp = this.props.remove_peers_resp || {};
        let list_peers_resp = this.props.list_peers_resp || {};
        let peer_list = (list_peers_resp.result && list_peers_resp.result.rows) || [];



        return (
            <div
                className={selected ? '' : 'hand-cursor'}
                onClick={() => {
                    if (!selected) {
                        isSelectable && typeof this.props.onSelected === 'function' && this.props.onSelected(itemID, data);
                        // For unclassified transaction
                        this.props.isRuleSelector && Array.isArray(data.rules) && this.props.onRuleSelected(data.id, data, {})
                    }
                }}
                style={{
                    background: selected ? COLORS.success_tertiary : COLORS.white,
                    border: `1px solid ${selected ? COLORS.success_primary : COLORS.border_basic}`,
                    boxShadow: `0px 0px 10px rgba(0, 0, 0, 0.15)`,
                    borderRadius: 5,
                    overflow: 'hidden',
                    // opacity:other_selected?0.4:1,
                    // maxHeight:600,
                    // overflowY:'scroll'
                }}>
                <div style={{
                    paddingLeft: 16, paddingRight: 16,
                    paddingTop: 8,
                    paddingBottom: 8
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap',

                    }}>
                        <div style={{ marginRight:12 }}>
                            <div
                                title={data.type == 'C' ? "Credit" : (data.type == 'D' ? "Debit" : "N/A")}
                                className={data.type === 'D' ? 'debit-circle' : data.type == 'C' ? 'credit-circle' : 'na-circle'}
                                style={{
                                    height: 34,
                                    width: 34,
                                    borderRadius: 18
                                }}
                            >
                                {data.type}
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <div className='heading-2'>{data.txn_date}</div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <div className='heading-2'>{data.transaction_id}</div>
                        </div>
                        <div style={{
                            flex: 1,
                            textAlign: 'right'
                        }}>
                            <div className='heading-2' style={{
                                color: COLORS.primary
                            }}>{formatMoney(data.amount)}</div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        marginTop: 8
                    }}>
                        <span className='sub-heading-3 word-break' style={{
                            color: COLORS.secondary
                        }}>
                            {data.description}
                        </span>
                        {/* <span className='hand-cursor' style={{marginLeft:8}}> */}
                        {/* <MoreHoriz
                            className='hand-cursor main-icon' style={{ marginLeft: 8 }}
                            titleAccess="Detail"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                typeof this.props.onViewDetailClicked === 'function' && this.props.onViewDetailClicked(itemID)
                            }}
                        /> */}
                        {/* </span> */}
                    </div>
                </div>
                {
                    selected &&
                    <React.Fragment>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            // alignItems: 'center',
                            flexWrap: 'nowrap',
                            // marginTop:8,
                            // paddingTop:8,
                            borderTop: `1px solid ${COLORS.border_basic}`,
                            paddingLeft: 16,
                            paddingRight: 16,
                        }}>
                            <Row type='flex' style={{
                                // display:'flex',
                                // flexDirection:'row',
                                width: '70%',
                                // flexWrap:'wrap',
                                // justifyContent:'space-between',
                                paddingTop: 16,
                                paddingBottom: 16,
                            }}>
                                <Col span={12}>
                                    <CustomStatsSmall
                                        label="DATATYPE"
                                        title={data.data_type_name || "N/A"}
                                        style={{
                                            marginBottom: 6,

                                        }}
                                        titleStyle={{
                                            fontSize:12
                                        }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <CustomStatsSmall
                                        label="SOURCE LABEL"
                                        title={data.source_label || "N/A"}
                                        style={{
                                            marginBottom: 6,
                                            marginLeft: 12
                                        }}
                                        titleStyle={{
                                            fontSize:12
                                        }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <CustomStatsSmall
                                        label="SERVICE TYPE"
                                        title={data.service_name || "N/A"}
                                        style={{
                                            marginBottom: 6
                                        }}
                                        titleStyle={{
                                            fontSize:12
                                        }}
                                    />
                                </Col>
                                <Col span={12}>
                                    <CustomStatsSmall
                                        label="SOURCE ID"
                                        title={data.source_id || "N/A"}
                                        style={{
                                            marginBottom: 6,
                                            marginLeft: 12
                                        }}
                                        titleStyle={{
                                            fontSize:12
                                        }}
                                    />
                                </Col>
                            </Row>
                            {/* <div style={{
                            display:'flex',
                            flexDirection:'row',
                            width:'70%',
                            flexWrap:'wrap',
                            justifyContent:'space-between',
                            paddingTop:16,
                            paddingBottom:16,
                        }}>
                           
                           
                            
                            
                        </div>
                         */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '25%',
                                flexWrap: 'wrap',
                                borderLeft: `1px solid ${COLORS.border_basic}`,
                                paddingTop: 16,
                                paddingBottom: 16,
                                paddingLeft: 8
                            }}>
                                {Array.isArray(data.flags) && data.flags.length > 0 ? data.flags.map((item) => {
                                    return <div style={{
                                        maxWidth: '100%',
                                        height: 'fit-content',
                                        marginBottom: 2
                                    }}><Tag title="FRAUD" className='tag-orange' style={{ marginRight: 6 }}>{item}</Tag></div>
                                }) : <span style={{ opacity: 0.5, }} className='sub-heading-4'>No Labels Added</span>}

                            </div>
                        </div>
                        {/* <Divider style={{marginTop:0,marginBottom:12}}/> */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            // paddingLeft: 16,
                            // paddingRight: 16,
                            width: '100%',
                            paddingTop: 0,
                            borderTop: `1px solid ${COLORS.border_basic}`,
                            borderBottom: `1px solid ${COLORS.border_basic}`,
                            paddingBottom: 0
                        }}>
                            <Collapse style={{
                                width: '100%',
                            }} className='customCollapse' accordion bordered={false} expandIconPosition='right'>
                                <Collapse.Panel header={<span className='sub-heading-3' style={{
                                            fontSize:12
                                        }}>PARSED DATA</span>} key="1">
                                    {data.parsed_data && Object.keys(data.parsed_data).length > 0 &&
                                        <Descriptions bordered column={1} className='smallPaddingWhiteDescription' size='small' layout='horizontal'>
                                            {Object.keys(data.parsed_data).map((key) => {
                                                if (!key.startsWith('__')) {
                                                    return <Descriptions.Item key={key} label={key} className='log-text' >
                                                        <Paragraph  style={{ marginBottom: 0 }}>
                                                            {typeof data.parsed_data[key] === 'string' ? data.parsed_data[key] : JSON.stringify(data.parsed_data[key])}
                                                        </Paragraph>
                                                    </Descriptions.Item>

                                                }
                                            })}
                                        </Descriptions>
                                    }
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            // paddingLeft: 16,
                            // paddingRight: 16,
                            width: '100%',
                            paddingTop: 0,
                            borderBottom: `1px solid ${COLORS.border_basic}`,
                            paddingBottom: 0
                        }}>
                            <Collapse style={{
                                width: '100%',
                            }} className='customCollapse whiteContentCollapse' accordion bordered={false} defaultActiveKey="1" expandIconPosition='right'>
                                <Collapse.Panel header={<span className='sub-heading-3' style={{
                                            fontSize:12
                                        }}>PEERS FOR THIS BATCH</span>} key="1">
                                    <ErrorWrapper error={list_peers_resp}
                                        onReload={() => {
                                            typeof this.props.onPeerRefresh==='function'&&this.props.onPeerRefresh();
                                        }}
                                        no_back_action={true}
                                    >
                                        <Table
                                            className='main-table single-column'
                                            size='small'
                                            pagination={{
                                                size:'small',
                                                defaultPageSize:10
                                            }}
                                            loading={list_peers_resp.fetching || remove_peers_resp.fetching}
                                            columns={peers_cols({
                                                onViewDetailClicked: (id) => {
                                                    typeof this.props.onViewDetailClicked === 'function' &&
                                                        this.props.onViewDetailClicked(id);
                                                },
                                                onRemoveClicked: (peer_id) => {
                                                    typeof this.props.onRemoveClicked === 'function' &&
                                                        this.props.onRemoveClicked(peer_id);
                                                }
                                            })}
                                            dataSource={peer_list}

                                        />
                                    </ErrorWrapper>
                                </Collapse.Panel>
                            </Collapse>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingLeft: 16,
                            paddingRight: 16,
                            width: '100%',
                            paddingTop: 12,
                            // borderTop:`1px solid ${COLORS.border_basic}`,
                            // borderBottom:`1px solid ${COLORS.border_basic}`,
                            paddingBottom: 12,
                            alignItems: 'center'
                        }}>

                            <a className='sub-heading-4' style={{
                                color: COLORS.primary
                            }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    typeof this.props.onViewDetailClicked === 'function' && this.props.onViewDetailClicked(itemID)
                                }}
                            >VIEW DETAIL</a>
                            {typeof this.props.onDeleteBatch==='function'&& 
                             <Popconfirm title="Do you want to remove all the peers in this batch?" onConfirm={() => {
                                // e.preventDefault();
                                //     e.stopPropagation()
                                    this.props.onDeleteBatch(itemID);
                
                            }}><a className='sub-heading-4' style={{
                                color: COLORS.danger_primary
                            }}
                            >Unbatch All</a></Popconfirm>
                            
                            }
                            {this.props.reconcile_btn}

                            {typeof this.props.onReconcile === 'function' &&
                                <TransparentButton
                                    disabled={this.props.disabled_reconcile}
                                    className='cta-reconcile'
                                    onClick={() => {
                                        this.props.onReconcile()
                                    }}
                                    icon={<PlaylistAddCheckOutlined />}
                                    label="RECONCILE"
                                />}
                            <a className='sub-heading-4' style={{
                                color: COLORS.danger_primary
                            }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation()
                                    typeof this.props.onSelected === 'function' && this.props.onSelected(null, null);
                                }}
                            >CLOSE</a>
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

export default TransactionBatchAggregatedItem
